import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.deploy;

const undeployData = createSelector([selector], (state) => state);

export default {
  undeployData
};
